var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1149_10370)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1149_10370",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12301 3.12276C3.33129 2.91448 3.66897 2.91448 3.87725 3.12276L8.00013 7.24564L12.123 3.12276C12.3313 2.91448 12.669 2.91448 12.8773 3.12276C13.0855 3.33104 13.0855 3.66873 12.8773 3.87701L8.75438 7.99989L12.8773 12.1228C13.0855 12.331 13.0855 12.6687 12.8773 12.877C12.669 13.0853 12.3313 13.0853 12.123 12.877L8.00013 8.75413L3.87725 12.877C3.66897 13.0853 3.33129 13.0853 3.12301 12.877C2.91473 12.6687 2.91473 12.331 3.12301 12.1228L7.24588 7.99989L3.12301 3.87701C2.91473 3.66873 2.91473 3.33104 3.12301 3.12276Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1149_10370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "#374151",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1149_10370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconThin);
export default __webpack_public_path__ + "static/media/closeIconThin.fcbcf970.svg";
export { ForwardRef as ReactComponent };